var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEllipsisH = function SvgEllipsisH(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.895 11.895A1.893 1.893 0 0 1 12 13.789a1.893 1.893 0 0 1-1.895-1.894c0-1.048.847-1.895 1.895-1.895s1.895.847 1.895 1.895zM19.105 10a1.893 1.893 0 0 0-1.894 1.895c0 1.048.846 1.894 1.894 1.894A1.893 1.893 0 0 0 21 11.895 1.893 1.893 0 0 0 19.105 10zm-14.21 0A1.893 1.893 0 0 0 3 11.895c0 1.048.847 1.894 1.895 1.894a1.893 1.893 0 0 0 1.894-1.894A1.893 1.893 0 0 0 4.895 10z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};

export default SvgEllipsisH;